import React, { useState, useEffect } from 'react';

const NetworkStatus = () => {
    const [isOnline, setIsOnline] = useState(navigator.onLine);

    useEffect(() => {
        const handleOnline = () => setIsOnline(true);
        const handleOffline = () => setIsOnline(false);

        window.addEventListener('online', handleOnline);
        window.addEventListener('offline', handleOffline);

        return () => {
            window.removeEventListener('online', handleOnline);
            window.removeEventListener('offline', handleOffline);
        };
    }, []);

    return (
        <div>
            {!isOnline && (
                <div style={{ color: 'red', padding: '10px', background: '#ffe6e6' }}>
                    No tienes conexión a internet. Por favor, verifica tu conexión.
                </div>
            )}
        </div>
    );
};

export default NetworkStatus;